import { StyleSheet } from "react-native";

export default StyleSheet.create({
  ContainerWrapper: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  Container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    maxWidth: 450,
    width: "100%",
  },
  MobileContainer: {
    width: "100%",
  },
  ContainerInner: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "stretch",
    overflow: "hidden",
    //border: "2px solid #e0e0e0",
    borderRadius: 8,
    backgroundColor: "transparent",
    width: "100%",
    height: "100%",
    flexDirection: "row",
  },
  LoginPageBackground: {
    height: " 100%",
    flex: 1,
    position: "relative",
  },
  LoginPageBackgoundWrapper: {
    flex: 1,
  },
  LoginPageMain: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    paddingBottom: 40,
    paddingTop: 16,
  },
  LogoWrapper: {
    alignItems: "center",
    marginBottom: 24,
  },
  OrDivider: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 4,
  },
  OrDividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: "#cccccc",
  },
  OrDividerText: {
    marginHorizontal: 10,
    color: "#888888",
    fontSize: 13,
  },
  VersionBadge: {
    backgroundColor: "#ffffff",
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 999,
    paddingHorizontal: 8,
    paddingVertical: 3,
    marginTop: 6,
  },
  Footer: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderTopWidth: 1,
    borderTopColor: "#e0e0e0",
    backgroundColor: "transparent",
  },
});
